import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, WithChildren} from '../../../../helpers'
import MenuIcon from "src/components/MenuIcon";

type Props = {
    to: string
    title: string
    hasBullet?: boolean
    handleAccordion: () => {},
    openAccordion: boolean
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
                                                                    children,
                                                                    to,
                                                                    title,
                                                                    hasBullet,
                                                                    handleAccordion,
                                                                    openAccordion
                                                                }) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)

    return (
        <div>
            <button className={clsx('SideBarMenuItem', {active: isActive})} onClick={() => handleAccordion()}>
                <div data-kt-menu-trigger='click'
                     className={clsx('w-full flex justify-between', {active: isActive})}>
                    <div className={"w-full flex gap-2 items-center"}>
                        <MenuIcon menu={title} color={isActive ? "#7E50EA" : "#8185A8"} size={"18"}/>
                        {hasBullet && (
                            <span className='menu-bullet'>
                                <span className='bullet bullet-dot'></span>
                            </span>
                        )}
                        <span className={clsx('SideBarItem', {active: isActive})}>{title}</span>
                    </div>
                </div>
            </button>
            {openAccordion &&
                <div>
                    {children}
                </div>
            }
        </div>

    )
}

export {SidebarMenuItemWithSub}
